import React from 'react';
import { Flex } from '@/ui/Flex/Flex';
import { IconClose } from '@/icons';
import styled, { css } from 'styled-components';
import { Button } from '../Button/Button';

const StyledSearchCnt = styled(Flex)`
  position: relative;
`;

const StyledResetSearchBtn = styled(Button)<{ isShowed: boolean }>`
  position: absolute;
  height: 100%;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  transition: opacity 0.2s 0s ease;
  z-index: 10;

  ${({ isShowed }) => css`
    &,
    &:hover {
      opacity: ${isShowed ? '1' : '0'};
      pointer-events: ${isShowed ? 'all' : 'none'};
    }
  `};
`;

const StyledSearchInput = styled.input`
  width: 100%;
  padding: 8px 16px;
  border-radius: 100vw;
  border: 1px solid ${({ theme }) => theme.color('#E0E0E0')};
  z-index: 1;
`;

interface SearchProps {
  readonly value: string;
  readonly setValue: React.Dispatch<React.SetStateAction<string>>;
  readonly id?: string;
  readonly testId?: string;
  readonly placeholder?: string;
}

export const Search = ({
  value: searchPhrase,
  setValue: setSearchPhrase,
  id,
  testId = 'search-field',
  placeholder,
}: SearchProps) => {
  const handleSearchPhrase = (value: string) => {
    setSearchPhrase(value);
  };

  const handleSearchPhraseReset = () => {
    setSearchPhrase('');
  };

  return (
    <StyledSearchCnt>
      <StyledSearchInput
        data-testid={`${testId}-input`}
        id={id}
        onChange={(e) => handleSearchPhrase(e.target.value)}
        placeholder={placeholder || 'File.mp4'}
        value={searchPhrase}
      />

      <StyledResetSearchBtn
        data-testid={`${testId}-button`}
        onClick={handleSearchPhraseReset}
        isShowed={Boolean(searchPhrase.length)}
        mode="transparent"
      >
        <IconClose />
      </StyledResetSearchBtn>
    </StyledSearchCnt>
  );
};
